import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors,
    DragEndEvent,
} from '@dnd-kit/core'
import {
    SortableContext,
    verticalListSortingStrategy,
    arrayMove,
} from '@dnd-kit/sortable'
import React, { useState } from 'react'
import uuid from 'react-uuid'
import { i18n } from '../../../../translate/i18n'
import { DinamicGridCreate, TypeDinamicGrid } from '../dinamyc-pages.types'
import { GridOverlay } from './gridOverlay'
import { SortableGrid } from './sortableGrid'


type Props = {
    setBlocks: React.Dispatch<React.SetStateAction<DinamicGridCreate[]>>
    blocks: DinamicGridCreate[]
}

export function TabGridPage({ setBlocks, blocks }: Props) {


    /*Usado em dragAnd Drop e Conteudos do Grid */

    const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 6 } }))
    const [open, setOpen] = useState(false)

    const addGrid = (type: TypeDinamicGrid) => {
        setBlocks((prev) => [...prev, { id: uuid(), type, order: prev.length + 1, configuration: {} }])
        setOpen(false)
    }
    const removeBlock = (id: string) => setBlocks((prev) => prev
        .filter((b) => b.id !== id)
        .map((b, index) => ({ ...b, order: index + 1 })))
    const updateBlock = (id: string, data: DinamicGridCreate) => {
        setBlocks((prev) => prev.map((block) => block.id === id ? data : block))
    }
    const onDragEnd = ({ active, over }: DragEndEvent) => {
        if (!over || active.id === over.id) return
        setBlocks((prev) => {
            const oldIndex = prev.findIndex((b) => b.id === active.id)
            const newIndex = prev.findIndex((b) => b.id === over.id)
            return arrayMove(prev, oldIndex, newIndex).map((b, index) => ({ ...b, order: index + 1 }))
        })
    }

    return (
        <section className='card border'>
            <div className='card-header min-h-60px d-flex justify-content-between align-items-center flex-wrap gap-3'>
                <div>
                    <h2 className='card-title fs-4 fw-bolder mb-1'>{i18n.t('agregador_dinamic_page.tabs.grid_title')}</h2>
                    <p className='text-muted fw-bold fs-7 mb-0'>{i18n.t('agregador_dinamic_page.tabs.grid_description')}</p>
                </div>
                <span className='badge text-bg-primary rounded-pill'>{blocks.length} {blocks.length === 1 ? 'grid' : 'grids'}</span>
                <div className='card-toolbar'>
                    <button type='button' className='btn btn-primary fw-bolder' onClick={() => setOpen(true)}>
                        <i className='bi bi-plus-lg me-2' /> {i18n.t('agregador_dinamic_page.tabs.grid_button')}
                    </button>
                </div>
            </div>
            <div className='card-body'>
                <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={onDragEnd}
                >
                    <SortableContext
                        items={blocks.map((b) => b.id)}
                        strategy={verticalListSortingStrategy}
                    >
                        <div>
                            <div className='d-grid gap-3'>
                                {blocks.length === 0 ? (
                                    <div className='border border-2 border-dashed rounded-3 text-center p-5'>
                                        <i className='bi bi-grid-3x3-gap display-6 text-muted' />
                                        <h3 className='h6 mt-3'>{i18n.t('agregador_dinamic_page.tabs.no_grid_title')}</h3>
                                        <p className='text-muted mb-3'>{i18n.t('agregador_dinamic_page.tabs.no_grid_message')}</p>
                                        <button type='button' className='btn btn-outline-primary' onClick={() => setOpen(true)}>
                                            <i className='bi bi-plus-lg me-2' /> {i18n.t('agregador_dinamic_page.tabs.grid_button')}
                                        </button>
                                    </div>
                                ) : (
                                        blocks.map((b) => <SortableGrid key={b.id} block={b} removeBlock={removeBlock} updateBlock={updateBlock} />)
                                    )}
                            </div>
                        </div>
                    </SortableContext>
                </DndContext>
            </div>

            <GridOverlay addGrid={(type: TypeDinamicGrid) => {
                addGrid(type)
            }} opened={open} onClose={() => setOpen(false)} />
        </section>

    )
}